// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DLVa","largestCol":"styles_largestCol__1C10Q","smallestCol":"styles_smallestCol__1okF6"};